import { AnswerResults } from './questions'

export enum ActivityStates {
    IN_PROGRESS = 'inProgress',
    FINISHED = 'finished',
}

export type Activity = {
    id: number
    registrationKeys: string[]
    nonContractRegistrationKeys: string[]
    answerResults: AnswerResults[]
    status: ActivityStates
}
